import { render, staticRenderFns } from "./workOrder-info.vue?vue&type=template&id=d24f0348&scoped=true&"
import script from "./workOrder-info.vue?vue&type=script&lang=js&"
export * from "./workOrder-info.vue?vue&type=script&lang=js&"
import style0 from "./workOrder-info.vue?vue&type=style&index=0&id=d24f0348&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24f0348",
  null
  
)

export default component.exports